import { statusTextForConsole } from "@graffer-inc/cloud-gov-core";
import { StatusTag } from "@graffer-inc/console-design-kit";

import { ApplyStatus } from "../../application/domain/application/application-entity";

interface ApplicationStatusTagProps {
  status: ApplyStatus;
  hiddenCheckIcon?: boolean;
}

export const ApplicationStatusTag = ({
  status,
  hiddenCheckIcon = false,
}: ApplicationStatusTagProps) => {
  switch (status) {
    case "UNTREATED":
      return <StatusTag type="WARN">{statusTextForConsole(status)}</StatusTag>;
    case "WIP":
      return (
        <StatusTag type={"PRIMARY"}>{statusTextForConsole(status)}</StatusTag>
      );
    case "CLOSED_COMPLETED":
      return (
        <StatusTag hiddenCheckIcon={hiddenCheckIcon} type={"SUCCESS"}>
          {statusTextForConsole(status)}
        </StatusTag>
      );
    case "CLOSED_REJECTED":
      return (
        <StatusTag type={"ERROR"}>{statusTextForConsole(status)}</StatusTag>
      );
    case "CLOSED_WITHDRAWN":
      return (
        <StatusTag type={"SECONDARY_ERROR"}>
          {statusTextForConsole(status)}
        </StatusTag>
      );
    default:
      return <span />;
  }
};

export const StatusRadios = ({
  filtered,
  current,
  onChange,
}: {
  filtered: ApplyStatus[];
  current: ApplyStatus | "";
  onChange: (s: ApplyStatus) => void;
}) => {
  return (
    <>
      {!filtered.includes("UNTREATED") && (
        <ApplicationStatusRadio
          status="UNTREATED"
          current={current}
          onChange={onChange}
        />
      )}
      {!filtered.includes("WIP") && (
        <ApplicationStatusRadio
          status="WIP"
          current={current}
          onChange={onChange}
        />
      )}
      {!filtered.includes("CLOSED_COMPLETED") && (
        <ApplicationStatusRadio
          status="CLOSED_COMPLETED"
          current={current}
          onChange={onChange}
        />
      )}
      {!filtered.includes("CLOSED_REJECTED") && (
        <ApplicationStatusRadio
          status="CLOSED_REJECTED"
          current={current}
          onChange={onChange}
        />
      )}
      {!filtered.includes("CLOSED_WITHDRAWN") && (
        <ApplicationStatusRadio
          status="CLOSED_WITHDRAWN"
          current={current}
          onChange={onChange}
        />
      )}
    </>
  );
};

const ApplicationStatusRadio = ({
  status,
  current,
  onChange,
}: {
  status: ApplyStatus;
  current: ApplyStatus | "";
  onChange: (s: ApplyStatus) => void;
}) => {
  return (
    <p className="mb-3">
      <label className="radio">
        <input
          type="radio"
          value={status}
          onChange={(e) => onChange(e.target.value as ApplyStatus)}
          checked={status === current}
          data-for-rpa-id={`target-${status}`}
          name="applyStatus"
        />{" "}
        <ApplicationStatusTag hiddenCheckIcon status={status} />
      </label>
    </p>
  );
};
